import * as React from "react"

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "default" | "outline"
}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(({ className, variant = "default", ...props }, ref) => {
  const baseClass = "badge"
  const variantClass = variant === "outline" ? "badge-outline" : ""

  return <div ref={ref} className={`${baseClass} ${variantClass} ${className || ""}`} {...props} />
})
Badge.displayName = "Badge"

export { Badge }
